import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import renderHTML from 'react-render-html';
import { connect } from 'react-redux';
import {
    NotificationContainer,
    NotificationManager,
} from 'react-notifications';
import RestService from 'utils/RestService';
import { ParsproService } from 'utils/ParsproService';
import { ModelService } from 'utils/ModelService';
import ViewSpinner from 'components/ViewSpinner';
import ViewPageToolbar from 'components/ViewPageToolbar';
import ViewEventList from 'containers/ViewEventList';
import GameRestOdds from 'components/GameRestOdds';
import {
    CAMPAIGN_IMAGE_PATH,
    CAMPAIGNS_COMPARE_WITH,
} from 'constants/appConfig';
import classNames from 'classnames';
import { browserHistory } from 'react-router';
import 'css/CampaignPage.scss';
import * as UiActions from 'actions/UiActions';
import * as EventObjectActions from 'actions/EventObjectActions';
import moment from 'moment';
import Button from 'ui/Button';
import { desktopOnly, detectMobile, notDesktop } from 'utils/UiHelper';

class CampaignPage extends Component {
    constructor() {
        super();
        this.initState = {
            isPending: false,
            campaign: null,
            events: null,
            isNeedSubscribe: true,
            wasSubscribed: false,
            blocked: false,
        };

        this.state = {
            isPending: false,
            campaign: null,
            events: null,
            isNeedSubscribe: true,
            wasSubscribed: false,
            blocked: false,
        };
    }

    componentWillMount() {
        if (this.props.auth.user) {
            this.canSubscribe(this.props.auth.user);
        }
        this.getData(this.props.params.seoUrl);
    }

    componentDidMount() {
        this.runAfterLoginActions();
    }

    runAfterLoginActions() {
        if (
            this.props.location.state &&
            typeof this.props.location.state.successLogin === 'function'
        ) {
            const {
                method,
                args = [],
                target,
            } = this.props.location.state.successLogin();
            if (
                typeof this[method] === 'function' &&
                target === 'CampaignPage'
            ) {
                this[method].apply(this, args);
            }
        }
    }

    canSubscribe(user, cb) {
        RestService.CanSubscribe(user.userId, (data) => {
            if (data.result === true) {
                if (data.allowed === false) {
                    this.setState({ isNeedSubscribe: false, blocked: true });
                }
            }
            if (cb) cb();
        });
    }

    getData(seoUrl) {
        this.setState({
            ...this.initState,
            isPending: true,
        });

        RestService.CampaignSeo(seoUrl, (data) => {
            if (!data || moment(data.ending).unix() < moment().unix()) {
                window.location.href = '/kampagner';
            }

            if (CAMPAIGNS_COMPARE_WITH.indexOf(data.platform) === -1) {
                window.location.href = '/kampagner';
            }

            if (this.state) {
                if (
                    window.localStorage.getItem(
                        'campaign-subscription-' + data.id
                    )
                ) {
                    this.setState({
                        campaign: data,
                        isNeedSubscribe: false,
                        wasSubscribed: true,
                    });
                } else {
                    this.setState({ campaign: data });
                }

                if (data.subscribe === '0') {
                    this.setState({ isNeedSubscribe: false });
                }

                if (data.markets) {
                    if (
                        data.markets.event_id &&
                        data.markets.event_id !== '0'
                    ) {
                        this.props.eventObjectActions.getEventObject(
                            data.markets.event_id
                        );

                        ParsproService.getEventById(data.markets.event_id).then(
                            (resp) => {
                                const res = resp.data;
                                if (res) {
                                    let events = [];
                                    let marketList = res.marketList;

                                    if (data.markets.market_id !== '0') {
                                        let marketListTemp = marketList.filter(
                                            (item) =>
                                                item.marketId + '' ===
                                                data.markets.market_id
                                        );

                                        res.marketList = marketListTemp;
                                    }

                                    if (data.markets.bet_nr !== '0') {
                                        marketList = res.marketList;

                                        if (marketList[0]) {
                                            let itemList = marketList[0].itemList.filter(
                                                (item) =>
                                                    item.betNr + '' ===
                                                    data.markets.bet_nr
                                            );

                                            marketList[0].itemList = itemList;

                                            res.marketList = marketList;
                                        }
                                    }

                                    events.push(res);

                                    this.setState({ events: events });
                                }
                            }
                        );
                    } else if (
                        data.markets.tournament_id &&
                        data.markets.tournament_id !== '0'
                    ) {
                        ParsproService.getByTournament(
                            9600,
                            data.markets.tournament_id
                        ).then((res) => {
                            const { data } = res;

                            if (data.length > 0) {
                                this.setState({ data });
                            }
                        });
                    } else if (
                        data.markets.group_id &&
                        data.markets.group_id !== '0'
                    ) {
                        ParsproService.getByGroup(
                            9600,
                            data.markets.group_id
                        ).then((res) => {
                            const events = res.data;
                            if (events.length > 0) {
                                this.setState({ events });
                            }
                        });
                    }
                }

                this.setState({ isPending: false });
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.user) {
            this.canSubscribe(nextProps.auth.user, () => {
                if (
                    !this.state.blocked &&
                    this.state.isNeedSubscribe === 'log-ind'
                    //TODO COULD BE MISTAKE
                ) {
                    this.subscribeToCampaign(
                        this.state.campaign.id,
                        1,
                        nextProps.auth.user
                    );
                }
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.params.seoUrl !== this.props.params.seoUrl) {
            this.getData(this.props.params.seoUrl);
        }
        const description = document.querySelector('.description');
        let iframe = null;
        if (description) {
            iframe = description.querySelector('iframe');
        }
        if (description && iframe) {
            iframe.setAttribute('scrolling', 'yes');
        }
    }

    onBackBtn() {
        browserHistory.push('/sport/kampagner');
    }

    onClickHandler(data) {
        if (data.button_text === 'OPRET KONTO') {
            this.props.uiActions.setSignupModalStatus(true);
            return;
        }
        window.open(data.external_url, '_blank');
    }

    subscribeToCampaign(id, type, user) {
        if (this.state.blocked) return false;
        if (type === 1) {
            RestService.CampaignSubscribe(user.userId, id, (data) => {
                if (data.result === true) {
                    window.localStorage.setItem(
                        'campaign-subscription-' + id,
                        true
                    );

                    this.setState({
                        isNeedSubscribe: false,
                        wasSubscribed: true,
                    });

                    NotificationManager.success('', 'Du er tilmeldt!', 4000);
                }
            });
        } else {
            this.props.uiActions.setLoginModalStatus(true);
        }
    }

    render() {
        const data = this.state.campaign;
        const ytSizes = desktopOnly()
            ? { width: 540, height: 320 }
            : { width: 300, height: 200 };
        const yplayer =
            data && data.youtube ? (
                <div className="p10 text-center">
                    <iframe
                        id="player"
                        title="youtube-player"
                        type="text/html"
                        {...ytSizes}
                        src={
                            'https://www.youtube.com/embed/' +
                            data.youtube +
                            '?enablejsapi=1&modestbranding=1&autohide=1&showinfo=0&controls=1&autoplay=0&rel=0'
                        }
                        frameBorder="0"
                    />
                </div>
            ) : null;

        const eventItems =
            data && data.markets && this.state.events ? (
                data.markets.market_id !== '0' ? (
                    <GameRestOdds
                        opened="yes"
                        groups={this.state.events[0].marketList}
                    />
                ) : (
                    <ViewEventList
                        events={ModelService.getSportTree(
                            this.props.sportTree.sportData,
                            this.state.events,
                            'array',
                            0,
                            null,
                            'sportId'
                        )}
                        listStyle={
                            data.markets.event_id === '0' &&
                            data.markets.tournament_id === '0' &&
                            data.markets.group_id !== '0'
                                ? null
                                : 'simple'
                        }
                    />
                )
            ) : null;

        const campaignView =
            data && !this.state.isPending ? (
                <div
                    className={classNames('campaign-page', {
                        desktop: desktopOnly(),
                    })}
                >
                    {detectMobile() ? (
                        <ViewPageToolbar
                            title={'Tilbage'}
                            onBackBtn={this.onBackBtn.bind(this)}
                        />
                    ) : null}

                    <img
                        className={classNames('m5', {
                            desktop: desktopOnly(),
                        })}
                        src={CAMPAIGN_IMAGE_PATH + data.image}
                        alt={data.title}
                        width="100%"
                    />
                    {data.title ? <p className="teaser">{data.title}</p> : null}

                    {yplayer}

                    {data.description ? (
                        <p className="description">
                            {renderHTML(data.description)}
                        </p>
                    ) : null}

                    {!this.state.blocked &&
                    this.state.isNeedSubscribe &&
                    this.props.auth.user ? (
                        <div className="p10 max-600 m40a">
                            <Button
                                active
                                margin="0"
                                onClick={this.subscribeToCampaign.bind(
                                    this,
                                    data.id,
                                    1,
                                    this.props.auth.user
                                )}
                            >
                                Tilmeld dig her
                            </Button>
                        </div>
                    ) : null}

                    {!this.state.blocked && this.state.wasSubscribed ? (
                        <div className="p10 max-600 m40a">
                            <Button margin="0" disabled>
                                Du er tilmeldt
                            </Button>
                        </div>
                    ) : null}

                    {this.state.isNeedSubscribe && !this.props.auth.user ? (
                        <div className="p10 max-600 m40a">
                            <Button
                                active
                                margin="0"
                                onClick={this.subscribeToCampaign.bind(
                                    this,
                                    data.id,
                                    2
                                )}
                            >
                                Log ind for at tilmelde dig
                            </Button>
                        </div>
                    ) : null}

                    {data.external_url && desktopOnly() ? (
                        <div className="p10 max-600 m40a">
                            <Button
                                active
                                margin="0"
                                onClick={this.onClickHandler.bind(this, data)}
                            >
                                {data.button_text || 'Læs mere'}
                            </Button>
                        </div>
                    ) : null}

                    {data.external_url && notDesktop() ? (
                        <div className="p10 max-600 m40a">
                            <Button
                                active
                                margin="0"
                                onClick={this.onClickHandler.bind(this, data)}
                            >
                                {data.button_text_mob || 'Læs mere'}
                            </Button>
                        </div>
                    ) : null}

                    {data.terms ? (
                        <div className="small-info-text p10 max-600 m0a terms">
                            {renderHTML(data.terms)}
                        </div>
                    ) : null}

                    {eventItems}
                </div>
            ) : (
                <ViewSpinner />
            );

        return (
            <div className="campaign-page pb80">
                {campaignView}
                <NotificationContainer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { sportTree: state.sportTree, auth: state.auth };
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
        eventObjectActions: bindActionCreators(EventObjectActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CampaignPage);
